import { httpService, IVoice } from 'shared';

const voicesEndpoint = '/voices';

export const voiceApi = {
  fetchAll: async () => {
    return await httpService.get<IVoice[]>(voicesEndpoint + '/');
  }
};
